export const LICENSE_TEST_IDS = {
  agreement: {
    accept: 'license.agreement.button.accept',
    acceptCheckbox: 'license.agreement.checkbox.accept',
    back: 'license.agreement.button.back',
    page: 'license.agreement.view.page',
  },
} as const;
